import { z } from "zod";
import { ElementPropertyTargetType, ElementViewBaseColumnType, ObjectMeta } from "@supernova-studio/model";

export const DTOElementViewColumnSharedAttributes = z.object({
  id: z.string(),
  persistentId: z.string(),
  width: z.number(),
});

export const DTOElementViewBasePropertyColumn = DTOElementViewColumnSharedAttributes.extend({
  type: z.literal("BaseProperty"),
  basePropertyType: ElementViewBaseColumnType,
});

export const DTOElementViewPropertyDefinitionColumn = DTOElementViewColumnSharedAttributes.extend({
  type: z.literal("PropertyDefinition"),
  propertyDefinitionId: z.string(),
});

export const DTOElementViewThemeColumn = DTOElementViewColumnSharedAttributes.extend({
  type: z.literal("Theme"),
  themeId: z.string(),
});

export const DTOElementViewColumn = z.discriminatedUnion("type", [
  DTOElementViewBasePropertyColumn,
  DTOElementViewPropertyDefinitionColumn,
  DTOElementViewThemeColumn,
]);

export const DTOElementView = z.object({
  meta: ObjectMeta,
  persistentId: z.string(),
  targetElementType: ElementPropertyTargetType,
  id: z.string(),
  isDefault: z.boolean(),
  columns: z.array(DTOElementViewColumn),
});

export const DTOElementViewsListResponse = z.object({
  elementDataViews: z.array(DTOElementView),
});

export type DTOElementView = z.infer<typeof DTOElementView>;
export type DTOElementViewsListResponse = z.infer<typeof DTOElementViewsListResponse>;
